import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-document-navigation-en',
  templateUrl: './help-document-navigation-en.component.html',
  styles: []
})
export class HelpDocumentNavigationEnComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
